"use strict";

exports.__esModule = true;
exports.ThemeProvider = ThemeProvider;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _resolveThemeVars = require("./resolveThemeVars");
var _base = _interopRequireDefault(require("../../Themes/base"));
var _excluded = ["theme"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Provides a Vimana theme to children.
 */
function ThemeProvider(_ref) {
  var _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? _base["default"] : _ref$theme,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, _extends({
    theme: (0, _resolveThemeVars.resolveThemeVars)(_base["default"], theme)
  }, extra));
}